import LANGUAGES from '../../_json/_languages.json';

export const COORDINATES_MULTIPLIER = 4;

export const LANGS = LANGUAGES.languages.filter(lang => lang.enabled !== false);

export const mapImageSize = { w: 17920, h: 7680 };

export const MAP_MIN_ZOOM = 3;
export const MAP_MAX_ZOOM = 6;
export const MAP_DEFAULT_ZOOM = 5;

export const STAMPCARD_RADIUS = 7; 